import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { Router } from '@angular/router';
import { ImportService } from '@services/imports/import.service';
import { MemoryService } from '@services/memory/memory.service';
import { DataTableComponent, DataTableEvent } from '../../../../components/data-table/data-table.component';
import { ImportTypeService } from '@services/import-types/import-type.service';

@Component({
    selector: 'composition-wizard-imports',
    templateUrl: './composition-wizard-imports.component.html',
    styleUrls: ['./composition-wizard-imports.component.scss'],
    providers: [ImportService, ImportTypeService],
    standalone: false
})
export class CompositionWizardImportsComponent implements OnInit {
  @ViewChild('assignedImportsTable') assignedImportsTable: DataTableComponent;
  @Input() composition: Models.Composition;

  public columnsAssignedImports = [{ prop: 'title' }];
  public columnsImportType = [{ prop: 'title' }];
  public columnsImport = [{ prop: 'title' }, { validate: '_id', name: 'Imported', icon: 'check_box' }];
  selectedImportType: false;

  public paramsImport: any;
  public assignedImportsProvider: MemoryService<Models.Import>;
  private assignedImports: Models.Import[];

  constructor(public importService: ImportService, public importTypeService: ImportTypeService, private router: Router) {
  }

  async ngOnInit() {
    this.assignedImports = [];
    this.assignedImportsProvider = new MemoryService(this.assignedImports);

    if (!!this.composition?.importIds?.length) {
      this.assignedImports = (await this.importService.find(0, 5000, { compositionId: this.composition._id })).data;
      this.updateAssignedImports();
    }
  }

  public async assignImport(event: DataTableEvent) {
    if (this.assignedImports.find(i => i?._id === event?.row?._id)) {
      this.assignedImports = this.assignedImports.filter(i => i?._id !== event?.row?._id);
    } else {
      this.assignedImports.push(await this.importService.get(event.row._id));
    }
    this.updateAssignedImports();
  }

  public removeAssignedImport(event: DataTableEvent): void {
    this.assignedImports = this.assignedImports.filter(i => i?._id !== event.row?._id);
    this.updateAssignedImports();
  }

  public onCustomImportType(event: DataTableEvent) {
    this.selectedImportType = this.selectedImportType === event.row._id ? false : event.row._id;
    this.paramsImport = this.selectedImportType === event.row._id ? {} : { typeId: event.row._id };
  }

  private updateAssignedImports(): void {
    this.composition.importIds = this.assignedImports.map(i => i._id);
    this.assignedImportsProvider.db = this.assignedImports;
    this.assignedImportsTable.refresh();
  }
}
